import React from 'react';
import SearchBar from "../../containers/SearchBar";
import {AvailabilityRangeMobile} from '../../containers/AvailabilityRange';
import CircularProgress from 'material-ui/CircularProgress';
import AvailabilityFooter from "../AvailabilityFooterComponent";
import AvailabilityPropertyComponent from "../AvailabilityPropertyComponent";
import {AvailabilitySearch} from "../../containers/App";

const AvailabilityMobileComponent = ({processing, criteria, properties}) => {
  return (
      <div className="availabilityComponent">
        {/*<div className="availabilitySearch">*/}
        {/*<SearchBar/>*/}
        {/*<AvailabilityRange/>*/}
        {/*</div>*/}
        <AvailabilitySearch/>
        <div className="availabilityContent">
        {criteria.properties && criteria.properties.map(property => {
          if(properties[property.id] !== undefined) {
            return (<AvailabilityPropertyComponent
                property={properties[property.id]}
                processing={properties[property.id].processing}
                isMobile={true}/>)
          }
        })
        }
        {processing && <div className="availabilitySearchProgress">
          <CircularProgress size={80} thickness={5}/></div>}
        </div>
        <AvailabilityFooter />
      </div>
  );
};

export default AvailabilityMobileComponent;


// WEBPACK FOOTER //
// ./src/components/mobile/AvailabilityMobileComponent.js